var Base64 = require('js-base64').Base64

export function splitPicUids(picUid) {
  if (!picUid) return []
  if (Array.isArray(picUid)) {
    return picUid
      .map((item) => String(item || '').trim())
      .filter(Boolean)
  }
  return String(picUid)
    .split(/[,;，]/)
    .map((item) => item.trim())
    .filter(Boolean)
}

export function joinPicUids(ids) {
  return splitPicUids(ids).join(',')
}

export function picUrl(store, id) {
  if (!id || !store || !store.state) return ''
  const token = Base64.encode(window.sessionStorage.getItem('token') || '')
  return (
    store.state.baseURL +
    store.state.uploadImage +
    '/' +
    id +
    '/800_0_100?token=' +
    token
  )
}

export function buildSrcList(store, picUid) {
  return splitPicUids(picUid).map((id) => picUrl(store, id))
}

export function buildFileList(store, picUid, name) {
  const title = name || '签署文件'
  return splitPicUids(picUid).map((id, index) => ({
    url: picUrl(store, id),
    uid: id,
    name: title + (index > 0 ? '-' + (index + 1) : '')
  }))
}

function normalizeWalkoffDate(value) {
  const text = String(value || '').trim()
  if (!text || text === '未退场' || text === '退场确认中') return ''
  const match = text.match(/^(\d{4}-\d{2}-\d{2})/)
  return match ? match[1] : ''
}

export function hasExitData(row) {
  const item = row || {}
  if (
    item.noteInfo === '退场' ||
    item.isExit === '退场' ||
    item.isExit === '0' ||
    item.isExit === 0
  ) {
    return true
  }
  return !!(
    normalizeWalkoffDate(item.walkoffDate) ||
    normalizeWalkoffDate(item.orgEndTime) ||
    normalizeWalkoffDate(item.walkOffDate)
  )
}

const REPORTED_CONTRACT_STATUS = [
  '已备案',
  '报备审核中',
  '变更审核中',
  '已终止',
  '1',
  '3',
  '0'
]

export function isSignedDocLocked(row, signedDoc) {
  const doc = signedDoc || {}
  const item = row || {}
  if (doc.lockWhen === 'notExit') {
    return !hasExitData(item)
  }
  if (doc.lockWhen === 'notReported') {
    const status = String(item.status || item.statusCode || '').trim()
    return REPORTED_CONTRACT_STATUS.indexOf(status) < 0
  }
  return !!item.signedDocLocked
}

export function reportPresetOf(row, signedDoc) {
  const doc = signedDoc || {}
  const code = doc.reportCode || ''
  const laborUidKey = doc.laborUidKey || 'uid'
  const laborTeamUidKey = doc.laborTeamUidKey || 'laborTeamUid'
  const contractUidKey = doc.contractUidKey || 'uid'
  const preset = {
    laborUid: '',
    laborTeamUid: '',
    contractUid: '',
    personUid: '',
    walkoffDate: ''
  }
  if (code === 'laborCompanyOut') {
    preset.laborTeamUid =
      row[laborTeamUidKey] || row.laborTeamUid || row.vProjectUid || row.orgUid || row.uid || ''
    preset.walkoffDate = normalizeWalkoffDate(row.walkoffDate)
    return preset
  }
  if (code === 'laborContractReport') {
    preset.contractUid = row[contractUidKey] || row.contractUid || row.uid || ''
    preset.laborTeamUid = row.laborTeamUid || row.vProjectUid || ''
    return preset
  }
  preset.laborUid = row[laborUidKey] || row.laborUid || row.uid || ''
  preset.laborTeamUid = row.laborTeamUid || row.vProjectUid || ''
  preset.walkoffDate = normalizeWalkoffDate(row.walkoffDate)
  return preset
}

export function esignUploadLabel(reportCode) {
  void reportCode
  return '上传图片'
}

export function buildEsignQuery(row, signedDoc) {
  const doc = signedDoc || {}
  const preset = reportPresetOf(row || {}, doc)
  return {
    reportCode: doc.reportCode || '',
    contractUid: preset.contractUid || '',
    laborTeamUid: preset.laborTeamUid || '',
    laborUid: preset.laborUid || '',
    walkoffDate: preset.walkoffDate || '',
    saveFun: doc.saveFun || '',
    refreshFun: doc.refreshFun || '',
    uid: (row && (row.uid || row.contractUid || row.laborUid)) || '',
    title: doc.imageLabel || doc.previewLabel || '电子签署'
  }
}

/** 在当前模块内打开电子签署（保留面包屑，不跳独立路由） */
export function openEsignPage(store, query) {
  const q = query || {}
  sessionStorage.setItem('esignQuery', JSON.stringify(q))
  const activeStep = store.state.activeStep
  sessionStorage.setItem(
    'esignActiveStep',
    activeStep === 0 || activeStep ? String(activeStep) : ''
  )
  const cur = store.state.currentStep || {}
  store.commit('formValuesSet', {
    key: 'esign',
    value: {}
  })
  // 签署页字段为 step:0，须先清掉上一业务页的步骤，否则字段被过滤不显示
  store.commit('baseSet', {
    key: 'activeStep',
    value: 0
  })
  store.commit('stepSet', {
    type: 'forward',
    forward: {
      label: q.title || '电子签署',
      theme: cur.theme || '',
      step: 'esignInfo',
      checkFun: ''
    }
  })
}

/** 从电子签署返回；opts.toList 时回到模块列表 */
export function leaveEsignPage(store, opts) {
  const toList = opts && opts.toList
  const saved = sessionStorage.getItem('esignActiveStep')
  try {
    sessionStorage.removeItem('esignActiveStep')
  } catch (e) {
    void e
  }

  if (toList) {
    const hist = store.state.historyStep || []
    let listStep = null
    for (let i = hist.length - 1; i >= 0; i--) {
      const s = hist[i]
      if (s && s.step && String(s.step).slice(-4) === 'List') {
        listStep = JSON.parse(JSON.stringify(s))
        break
      }
    }
    if (listStep) {
      store.commit('stepSet', { type: 'toAny', toAny: listStep })
      store.commit('baseSet', { key: 'formError', value: {} })
      const cf = listStep.checkFun
      if (cf && typeof cf === 'string') {
        store.dispatch(cf)
      } else if (cf && cf instanceof Array) {
        store.dispatch(cf[0], cf[1])
      }
      return
    }
  }

  // stepSet 会把 activeStep 置 NaN，用 session 让表单重挂时恢复步骤
  if (saved !== null && saved !== '' && !Number.isNaN(Number(saved))) {
    try {
      sessionStorage.setItem('esignRestoreStep', String(Number(saved)))
    } catch (e) {
      void e
    }
  }
  store.commit('stepSet', { type: 'back' })
}
